<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px; background: white">
            <ion-item>
                <ion-thumbnail slot="start" style="height: 100%; padding: 15px 0">
                    <img :src="image" style="max-width: 65px; height: 100px; object-fit: contain;"/>
                </ion-thumbnail>
                <ion-label mode="md" class="ion-text-wrap">
                    <h2>{{ title }}</h2>
                    <p>{{ description }}</p>
                </ion-label>
            </ion-item>
            <ion-card-content style="text-align:left">
                <p v-if="extract"><strong>Ekstrakt: </strong>{{ extract }}</p>
                <p v-if="alcohol"><strong>Zawartość alkoholu: </strong>{{ alcohol }}</p>
                <p v-if="ingredients"><strong>Opis składu: </strong>{{ ingredients }}</p>
                <p v-if="gentian"><strong>Goryczka: </strong>{{ gentian }}</p>
                <p v-if="color"><strong>Barwa: </strong>{{ color }}</p>
                <p v-if="serve"><strong>Najlepiej smakuje z: </strong>{{ serve }}</p>
                <p v-if="temperature"><strong>Temperatura podania: </strong>{{ temperature }}</p>
                <p v-if="url"><strong>Składniki odżywcze: </strong><a :href="url" class="text-gold" target="_blank">{{ url_label }}</a></p>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    export default {
        name: 'ItemBrandBeer',
        props: ['index', 'title', 'description', 'extract', 'alcohol', 'ingredients', 'gentian', 'color', 'serve', 'temperature', 'image', 'url', 'url_label'],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
    }
</script>